import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsYarnComponent } from './simple-icons-yarn.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsYarnComponent ],
    exports:      [ SimpleIconsYarnComponent ],
    bootstrap:    []
})
export class SimpleIconsYarnModule {}
